module.exports = __webpack_public_path__ + "static/scale-model-of-charles-krutch-park-in-knoxville-tennessee-eebe24645096aeb624c6a7f6e6f34613.png";